import React, { FC, useMemo, useState } from 'react';
import { Form, Button, Space, notification } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';
import { ICategory } from '../../../../../interfaces';
import styles from '../../../../../pages/applications/create/create.module.scss';
import { Col, Row } from 'antd';
import { useSelect } from '@refinedev/antd';
import cn from 'classnames';
import {
    FormItem,
    Input,
    InputNumber,
    Select,
    SelectProps,
} from 'components/ui';

interface IContainedItemsProps {
    fieldKey: number;
}

export const ContainedItems: FC<IContainedItemsProps> = ({ fieldKey }) => {
    const t = useTranslate();
    const form = Form.useFormInstance();
    const [packType, setPackType] = useState<string>('medication');
    let isMedication = packType === 'medication';
    let isPackaging = packType === 'package';

    const { selectProps: amountUnitIds } = useSelect<ICategory>({
        resource: 'dictionary/measurement-units',
        defaultValue: [],
        optionLabel: 'name',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: 'server',
        },
    }) as {
        selectProps: SelectProps<ICategory>;
    };

    let compositions = useMemo(
        () => form.getFieldValue('compositions') ?? [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [form?.getFieldValue('compositions')]
    );
    let packages = useMemo(
        () => form.getFieldValue('packages') ?? [],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [form?.getFieldValue('packages')]
    );
    let compositionList = useMemo(
        () => [
            {
                label: 'Препарат',
                options: compositions.map((composition: any) => ({
                    label: composition?.description,
                    value: composition?.number,
                    disabled: isPackaging,
                })),
            },
            {
                label: 'Упаковка',
                options: packages.map((packaging: any) => ({
                    label: packaging?.description,
                    value: packaging?.id,
                    disabled: isMedication,
                })),
            },
        ],
        [compositions, packages, isPackaging, isMedication]
    );
    let packingList = useMemo(
        () => [
            {
                value: 'medication',
                label: 'Препарат',
            },
            {
                value: 'package',
                label: 'Упаковка',
            },
            {
                value: 'other',
                label: 'Інше',
            },
        ],
        []
    );

    return (
        <>
            <Form.List name={[fieldKey, 'containedItems']}>
                {(containedItems, { add, remove }, { errors, warnings }) => (
                    <>
                        {containedItems.map((item, index) => {
                            let current = form.getFieldValue([
                                'packages',
                                fieldKey,
                                'containedItems',
                                item.name,
                                'type',
                            ]);

                            let hasList =
                                current === 'medication' ||
                                current === 'package';

                            return (
                                <Space
                                    key={item.key}
                                    align="start"
                                    className={cn(
                                        styles.holder,
                                        styles.containedItemsWrap
                                    )}
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <Row
                                        gutter={[16, 16]}
                                        style={{
                                            width: '100%',
                                        }}
                                    >
                                        <Col span={24}>
                                            <FormItem
                                                {...item}
                                                name={[item.name, 'type']}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    item.fieldKey,
                                                    'type',
                                                ]}
                                                key={index}
                                            >
                                                <Select
                                                    label={t(
                                                        'applications.fields.type'
                                                    )}
                                                    options={packingList}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    onChange={(
                                                        value: string
                                                    ) => {
                                                        setPackType(value);
                                                    }}
                                                />
                                            </FormItem>
                                        </Col>

                                        {hasList ? (
                                            <>
                                                <Col span={24}>
                                                    <FormItem
                                                        {...item}
                                                        name={[
                                                            item.name,
                                                            'packaging_options',
                                                        ]}
                                                        //@ts-ignore
                                                        fieldKey={[
                                                            //@ts-ignore
                                                            item.fieldKey,
                                                            'packaging_options',
                                                        ]}
                                                        key={index}
                                                    >
                                                        <Select
                                                            label="&nbsp;"
                                                            options={
                                                                compositionList
                                                            }
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            onChange={(
                                                                value: string
                                                            ) => {
                                                                if (value) {
                                                                    let itemId =
                                                                        fieldKey +
                                                                        1;
                                                                    let samePackaging =
                                                                        itemId ===
                                                                        +value;

                                                                    let payload: any[];

                                                                    if (
                                                                        samePackaging
                                                                    ) {
                                                                        notification.error(
                                                                            {
                                                                                message: `${t(
                                                                                    'You cannot choose the same package'
                                                                                )}`,
                                                                            }
                                                                        );

                                                                        let containedItems =
                                                                            form.getFieldValue(
                                                                                [
                                                                                    'packages',
                                                                                    fieldKey,
                                                                                    'containedItems',
                                                                                ]
                                                                            );

                                                                        let filtered =
                                                                            containedItems.filter(
                                                                                (
                                                                                    item: any,
                                                                                    itemIndex: any
                                                                                ) => {
                                                                                    return (
                                                                                        index !==
                                                                                        itemIndex
                                                                                    );
                                                                                }
                                                                            );

                                                                        payload =
                                                                            [
                                                                                {
                                                                                    name: [
                                                                                        'packages',
                                                                                        fieldKey,
                                                                                        'containedItems',
                                                                                    ],
                                                                                    value: filtered,
                                                                                },
                                                                            ];
                                                                    } else {
                                                                        payload =
                                                                            [
                                                                                {
                                                                                    name: [
                                                                                        'packages',
                                                                                        fieldKey,
                                                                                        'containedItems',
                                                                                        item.name,
                                                                                        'itemId',
                                                                                    ],
                                                                                    value: value,
                                                                                },
                                                                            ];
                                                                    }

                                                                    form.setFields(
                                                                        payload
                                                                    );
                                                                }
                                                            }}
                                                            allowClear={true}
                                                        ></Select>
                                                    </FormItem>
                                                </Col>
                                                <Col
                                                    span={24}
                                                    style={{
                                                        display: 'none',
                                                    }}
                                                >
                                                    <FormItem
                                                        {...item}
                                                        name={[
                                                            item.name,
                                                            'itemId',
                                                        ]}
                                                        //@ts-ignore
                                                        fieldKey={[
                                                            //@ts-ignore
                                                            item.fieldKey,
                                                            'itemId',
                                                        ]}
                                                        key={index}
                                                    >
                                                        <InputNumber
                                                            label={t(
                                                                'applications.fields.citems_item_id'
                                                            )}
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                        />
                                                    </FormItem>
                                                </Col>
                                            </>
                                        ) : null}

                                        <Col span={24}>
                                            <FormItem
                                                {...item}
                                                name={[item.name, 'itemText']}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    item.fieldKey,
                                                    'itemText',
                                                ]}
                                                key={index}
                                            >
                                                <Input
                                                    label={t(
                                                        'applications.fields.citems_item_text'
                                                    )}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem
                                                {...item}
                                                name={[item.name, 'amount']}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    item.fieldKey,
                                                    'amount',
                                                ]}
                                                key={index}
                                            >
                                                <InputNumber
                                                    label={t(
                                                        'applications.fields.citems_amount'
                                                    )}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <FormItem
                                                {...item}
                                                name={[
                                                    item.name,
                                                    'amountUnitId',
                                                ]}
                                                //@ts-ignore
                                                fieldKey={[
                                                    //@ts-ignore
                                                    item.fieldKey,
                                                    'amountUnitId',
                                                ]}
                                                key={index}
                                            >
                                                <Select
                                                    label={t(
                                                        'applications.fields.citems_amount_unit_id'
                                                    )}
                                                    {...amountUnitIds}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col span={24}>
                                            <Row
                                                justify="end"
                                                gutter={[16, 16]}
                                            >
                                                <Col>
                                                    <Button
                                                        type="text"
                                                        danger
                                                        icon={
                                                            <MinusCircleOutlined />
                                                        }
                                                        onClick={() =>
                                                            remove(item.name)
                                                        }
                                                        aria-label={t(
                                                            'buttons.delete'
                                                        )}
                                                    >
                                                        {t('buttons.delete')}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Space>
                            );
                        })}
                        <Form.Item noStyle>
                            <Button type="dashed" onClick={() => add()}>
                                <PlusOutlined />{' '}
                                {t('applications.fields.add_contained_items')}
                            </Button>
                            <Form.ErrorList errors={errors} />
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </>
    );
};
